import * as type from '../ActionTypes';

const stripAccountInitialState = {
  stripAccountData: {},
  loading: false,
  error: null,
  stripAccountStatus: false
};

export function createStripAccountReducer(state = stripAccountInitialState, action: any) {
  switch (action.type) {
    case type.CREATE_STRIPE_ACCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        stripAccountStatus: false
      };
    case type.CREATE_STRIPE_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        stripAccountData: action.data,
        error: null,
        stripAccountStatus: true
      };
    case type.CREATE_STRIPE_ACCOUNT_FAILURE:
      return {
        ...state,
        loading: false,
        stripAccountData: {},
        error: action.error,
        stripAccountStatus: false
      };

    default:
      return state;
  }
}
const stripeFeeCalculationInitialState = {
  stripeFeeData: {},
  loading: false,
  error: null,
  stripeFeeStatus: false
};

export function stripeFeeCalculationReducer(state = stripeFeeCalculationInitialState, action: any) {
  switch (action.type) {
    case type.STRIPE_FEE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        stripeFeeData: {},
        stripeFeeStatus: false
      };
    case type.STRIPE_FEE_SUCCESS:
      return {
        ...state,
        loading: false,
        stripeFeeData: action.data,
        error: null,
        stripeFeeStatus: true
      };
    case type.STRIPE_FEE_FAILURE:
      return {
        ...state,
        loading: false,
        stripeFeeData: {},
        error: action.error,
        stripeFeeStatus: false
      };
    case type.RESET_STRIPE_FEE:
      return {
        ...stripeFeeCalculationInitialState
      };

    default:
      return state;
  }
}

const stripePaymentCheckoutInitialState = {
  stripeCheckoutData: {},
  checkoutLoading: false,
  checkoutError: null,
  stripeCheckoutStatus: false
};

export function stripePaymentCheckoutReducer(
  state = stripePaymentCheckoutInitialState,
  action: any
) {
  switch (action.type) {
    case type.STRIPE_PAYMENT_CHECKOUT_REQUEST:
      return {
        ...state,
        checkoutLoading: true,
        checkoutError: null,
        stripeCheckoutData: {},
        stripeCheckoutStatus: false
      };
    case type.STRIPE_PAYMENT_CHECKOUT_SUCCESS:
      return {
        ...state,
        checkoutLoading: false,
        stripeCheckoutData: action.data,
        checkoutError: null,
        stripeCheckoutStatus: true
      };
    case type.STRIPE_PAYMENT_CHECKOUT_FAILURE:
      return {
        ...state,
        checkoutLoading: false,
        stripeCheckoutData: {},
        checkoutError: action.error || 'Something went wrong',
        stripeCheckoutStatus: false
      };
    case type.STRIPE_PAYMENT_CHECKOUT_RESET:
      return {
        ...stripePaymentCheckoutInitialState
      };

    default:
      return state;
  }
}
